// extracted by mini-css-extract-plugin
export default {"container":"admin-staff-toggle_container__u76Zi","containerAdminstaff":"admin-staff-toggle_containerAdminstaff__sLY4K"};